import React, { useState } from "react";
import ContactForm from './ContactForm';
import MapComponent from "./MapComponent";
// Card component
const Card = ({ title, description }) => {
    const cardStyles = {
        border: "1px solid #ddd",
        borderRadius: "8px",
        padding: "20px",
        margin: "10px",
        boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
        textAlign: "left",
        width: "280px",
        backgroundColor: "#fff",
    };

    return (
        <div style={cardStyles}>
            <h3 style={{ marginBottom: "10px", fontSize: "18px" }}>{title}</h3>
            <p style={{ fontSize: "14px", color: "#000", }}>{description}</p>
        </div>
    );
};

const Talktoustabs = () => {
    const [activeTab, setActiveTab] = useState("tab1");

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    const styles = {
        container: {
            fontFamily: "Arial, sans-serif",
            width: "100%", // Use full width
            maxWidth: "1200px", // Add a max width for larger screens
            margin: "0 auto",
            padding: "20px",
        },
        tabNav: {
            // display: "flex",
            justifyContent: "center",
            borderBottom: "2px solid #ddd",
            paddingBottom: "10px",
            marginTop: "50px",
        },
        tabButton: {
            padding: "10px 20px",
            cursor: "pointer",
            border: "none",
            background: "none",
            fontSize: "16px",
            fontWeight: "bold",
            color: "#555",
            outline: "none",
            transition: "color 0.3s, background-color 0.3s",
            borderRadius: "50px",
            margin: "0 10px",
            backgroundColor: "#f0f0f0",
            marginBottom:"10px"
        },
        activeTabButton: {
            backgroundColor: "rgb(236 115 34)",
            color: "#fff",
        },
        tabContent: {
            padding: "20px 0",
            fontSize: "16px",
            color: "#333",
            lineHeight: "1.5",
            display: "block", // Block layout for full width
            width: "100%", // Ensure full width
            margin: "0 auto", // Center the content
        },
    };

    return (
        <div style={styles.container}>
            <div style={styles.tabNav}>
                <button
                    style={{
                        ...styles.tabButton,
                        ...(activeTab === "tab1" ? styles.activeTabButton : {}),
                    }}
                    onClick={() => handleTabClick("tab1")}
                 >
                    CUSTOMERS
                </button>
                <button
                    style={{
                        ...styles.tabButton,
                        ...(activeTab === "tab2" ? styles.activeTabButton : {}),
                    }}
                    onClick={() => handleTabClick("tab2")}
                 >
                    JOB SEEKERS
                </button>
                {/* <button
                    style={{
                        ...styles.tabButton,
                        ...(activeTab === "tab3" ? styles.activeTabButton : {}),
                    }}
                    onClick={() => handleTabClick("tab3")}
                 >
                    SUPPLIERS
                </button>
                <button
                    style={{
                        ...styles.tabButton,
                        ...(activeTab === "tab4" ? styles.activeTabButton : {}),
                    }}
                    onClick={() => handleTabClick("tab4")}
                 >
                    PARTNERS
                </button> */}
                
            </div>

            <div style={styles.tabContent}>
                {activeTab === "tab1" && (
                    <div className="container-fluid">
                        <div className="row">
                            {/* Contact Form */}
                            <div className="col-md-6">
                                <form>
                                    <div className="form-group">
                                        <input
                                            type="text"
                                            name="name"
                                            className="form-control"
                                            placeholder="Your Name"
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <input
                                            type="email"
                                            name="email"
                                            className="form-control"
                                            placeholder="Your Email"
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <input
                                            type="tel"
                                            name="phone"
                                            className="form-control"
                                            placeholder="Your Phone Number"
                                            maxLength="10"
                                            required
                                        />
                                    </div>
                                    <div className="form-group message-data">
                                        <textarea
                                            name="message"
                                            className="form-control"
                                            placeholder="Your Message"
                                            required
                                            rows="8" // Adjust the number to control the height of the textarea
                                        />
                                    </div>

                                    <button type="submit" className="btn " style={{ background: 'rgb(236 115 34)', color: "#fff" }}>
                                        Send Now
                                    </button>
                                </form>
                            </div>
                            {/* Map */}
                            <div className="col-md-6">
                                 <MapComponent />
                                {/* <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7610.7433924449315!2d78.38240638937562!3d17.489761383659552!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb918dab342375%3A0x180a04af0c47f594!2sManjeera%20Trinity%20Corporate!5e0!3m2!1sen!2sin!4v1723212055136!5m2!1sen!2sin"
                                    width="100%"
                                    height="450"
                                    style={{ border: 0 }}
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                ></iframe> */}
                            </div>
                        </div>
                    </div>
                )}
                {activeTab === "tab2" && <div className="container-fluid">
                    <div className="row">
                        {/* Contact Form */}
                        <div className="col-md-6">
                            <form>
                                <div className="form-group">
                                    <input
                                        type="text"
                                        name="name"
                                        className="form-control"
                                        placeholder="Your Name"
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="email"
                                        name="email"
                                        className="form-control"
                                        placeholder="Your Email"
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="tel"
                                        name="phone"
                                        className="form-control"
                                        placeholder="Your Phone Number"
                                        maxLength="10"
                                        required
                                    />
                                </div>
                                <div className="form-group message-data">
                                    <textarea
                                        name="message"
                                        className="form-control"
                                        placeholder="Your Message"
                                        required
                                        rows="8" // Adjust the number to control the height of the textarea
                                    />
                                </div>

                                <button type="submit" className="btn " style={{ background: 'rgb(254 153 0)', color: "#fff" }}>
                                    Send Now
                                </button>
                            </form>
                        </div>
                        {/* Map */}
                        <div className="col-md-6">
                             <MapComponent />
                            {/* <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7610.7433924449315!2d78.38240638937562!3d17.489761383659552!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb918dab342375%3A0x180a04af0c47f594!2sManjeera%20Trinity%20Corporate!5e0!3m2!1sen!2sin!4v1723212055136!5m2!1sen!2sin"
                                width="100%"
                                height="450"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            ></iframe> */}
                        </div>
                    </div>
                </div>}
                
                {activeTab === "tab3" && <div className="container-fluid">
                    <div className="row">
                        {/* Contact Form */}
                        <div className="col-md-6">
                            <form>
                                <div className="form-group">
                                    <input
                                        type="text"
                                        name="name"
                                        className="form-control"
                                        placeholder="Your Name"
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="email"
                                        name="email"
                                        className="form-control"
                                        placeholder="Your Email"
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="tel"
                                        name="phone"
                                        className="form-control"
                                        placeholder="Your Phone Number"
                                        maxLength="10"
                                        required
                                    />
                                </div>
                                <div className="form-group message-data">
                                    <textarea
                                        name="message"
                                        className="form-control"
                                        placeholder="Your Message"
                                        required
                                        rows="8" // Adjust the number to control the height of the textarea
                                    />
                                </div>

                                <button type="submit" className="btn " style={{ background: 'rgb(254 153 0)', color: "#fff" }}>
                                    Send Now
                                </button>
                            </form>
                        </div>
                        {/* Map */}
                        <div className="col-md-6">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7610.7433924449315!2d78.38240638937562!3d17.489761383659552!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb918dab342375%3A0x180a04af0c47f594!2sManjeera%20Trinity%20Corporate!5e0!3m2!1sen!2sin!4v1723212055136!5m2!1sen!2sin"
                                width="100%"
                                height="450"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            ></iframe>
                        </div>
                    </div>
                </div>}
                {activeTab === "tab4" && <div className="container-fluid">
                    <div className="row">
                        {/* Contact Form */}
                        <div className="col-md-6">
                            <form>
                                <div className="form-group">
                                    <input
                                        type="text"
                                        name="name"
                                        className="form-control"
                                        placeholder="Your Name"
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="email"
                                        name="email"
                                        className="form-control"
                                        placeholder="Your Email"
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="tel"
                                        name="phone"
                                        className="form-control"
                                        placeholder="Your Phone Number"
                                        maxLength="10"
                                        required
                                    />
                                </div>
                                <div className="form-group message-data">
                                    <textarea
                                        name="message"
                                        className="form-control"
                                        placeholder="Your Message"
                                        required
                                        rows="8" // Adjust the number to control the height of the textarea
                                    />
                                </div>

                                <button type="submit" className="btn " style={{ background: 'rgb(254 153 0)', color: "#fff" }}>
                                    Send Now
                                </button>
                            </form>
                        </div>
                        {/* Map */}
                        <div className="col-md-6">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7610.7433924449315!2d78.38240638937562!3d17.489761383659552!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb918dab342375%3A0x180a04af0c47f594!2sManjeera%20Trinity%20Corporate!5e0!3m2!1sen!2sin!4v1723212055136!5m2!1sen!2sin"
                                width="100%"
                                height="450"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            ></iframe>
                        </div>
                    </div>
                </div>}
                {activeTab === "tab5" && <div className="container-fluid">
                    <div className="row">
                        {/* Contact Form */}
                        <div className="col-md-6">
                            <form>
                                <div className="form-group">
                                    <input
                                        type="text"
                                        name="name"
                                        className="form-control"
                                        placeholder="Your Name"
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="email"
                                        name="email"
                                        className="form-control"
                                        placeholder="Your Email"
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="tel"
                                        name="phone"
                                        className="form-control"
                                        placeholder="Your Phone Number"
                                        maxLength="10"
                                        required
                                    />
                                </div>
                                <div className="form-group message-data">
                                    <textarea
                                        name="message"
                                        className="form-control"
                                        placeholder="Your Message"
                                        required
                                        rows="8" // Adjust the number to control the height of the textarea
                                    />
                                </div>

                                <button type="submit" className="btn " style={{ background: 'rgb(254 153 0)', color: "#fff" }}>
                                    Send Now
                                </button>
                            </form>
                        </div>
                        {/* Map */}
                        <div className="col-md-6">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7610.7433924449315!2d78.38240638937562!3d17.489761383659552!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb918dab342375%3A0x180a04af0c47f594!2sManjeera%20Trinity%20Corporate!5e0!3m2!1sen!2sin!4v1723212055136!5m2!1sen!2sin"
                                width="100%"
                                height="450"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            ></iframe>
                        </div>
                    </div>
                </div>}
            </div>
        </div>
    );
};

export default Talktoustabs;
